import React, { useEffect, useRef, useState } from 'react';
import {
    fromDateInputToDdSlashMmSlashYyyy,
    fromIso8601ToDdSlashMmSlashYyyy,
    isAfterToday,
    isBeforeToday
} from "../../utils/dateUtils";
import { extractFirstWordsWithoutImages, sanitizedMsg } from "../../utils/htmlUtils";
import { replaceUrlPlaceholders } from "react-utils";
import { useLocation, useNavigate } from "react-router-dom";
import { deleteContribution, getContributions, getSousCategoriesRef } from "../../api/contributionsService";

import './DisplayContributions.scss'
import PaginationSimple from "../Pagination/PaginationSimple";
import { isAdminKc, isRenderedAsAdmin } from "../../utils/keycloakUtils";
import { useDispatch, useSelector } from "react-redux";
import { updateKeycloak } from "../../Redux/keycloak/keycloakReducer";
import { fetchContributionsAndSousCategories } from "../../Redux/resources/resourcesReducer";

export default function DisplayContributions() {

    // TODO mettre un loading
    // TODO aller chercher les sous catégories en db
    // TODO Voir pour extraire le bouton dropdown pour le rendre générique, notamment la partie avec le click out
    // TODO afficher les filtre en fonction d'un bouton paramètre
    // TODO ajouter des filtres en mode admin pour récupérer les publications dépassées et celles pas encore publiés

    const {
        keycloakReduce,
        contributions,
        nombreContributions,
        sousCategoriesRef,
        loadingContributions,
    } = useSelector(state => ({
        ...state.keycloakReducer,
        ...state.resourcesReducer,
    }))

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const pathname = location?.pathname

    const CONF = window?.confPub;
    const UI = CONF?.UI?.RECHERCHE_PERSONNE;
    const INPUTS = UI?.INPUTS;
    const ROUTES = CONF?.ROUTES;

    const isInfosGeneralesPage = pathname.includes(ROUTES?.PAGES?.INFOS_GENERALES)
    const Container = isInfosGeneralesPage ? 'main' : 'section';

    const dropdownRef = useRef(null);

    const [currentPage, setCurrentPage] = useState(1)
    const contributionsPerPage = 5;

    const [contributionsFilter, setContributionsFilter] = useState({
        locale: false,
        nationale: false,
        sousCategories: [],
        dateMin: "",
        dateMax: "",
        admin: isRenderedAsAdmin(keycloakReduce),
    })

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;

        setContributionsFilter(prevState => {
            const newSousCategories = checked
                ? [...prevState.sousCategories, value]
                : prevState.sousCategories.filter(item => item !== value);

            return {
                ...prevState,
                sousCategories: newSousCategories
            };
        });
    };


    const token = localStorage.getItem('accessToken')
    // TODO voir pour faire un appel en fonction du changement de page et/ou d'heure
    useEffect(() => {

        if (keycloakReduce?.decodedToken?.idGrm && token) {

            dispatch(fetchContributionsAndSousCategories(getParamsContribustions()))
        }

    }, [currentPage, keycloakReduce, token]);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const voirContribution = (id) => {

        const urlVoirContribution = replaceUrlPlaceholders(ROUTES?.PAGES?.CONTRIBUTIONS?.VOIR_CONTRIBUTION,
            { id: id });

        navigate(urlVoirContribution)
    }

    const handleInput = (e) => {

        const value = e?.target?.value
        const name = e?.target?.name
        const checked = e?.target?.checked

        let majContributionFilter = {
            ...contributionsFilter
        }

        switch (name) {

            case "locale" :
            case "nationale" :
                majContributionFilter = {
                    ...majContributionFilter,
                    [name]: checked,
                }
                break
            case "dateMin" :
            case "dateMax" :
                majContributionFilter = {
                    ...majContributionFilter,
                    [name]: value,
                }
                break
        }

        setContributionsFilter(majContributionFilter)
    }

    const rechercheContributions = async (e) => {

        e.preventDefault()

        dispatch(fetchContributionsAndSousCategories(getParamsContribustions()))

        setCurrentPage(1)
    }

    const supprimerContribution = async (id) => {

        try {
            const contributionDelete = await deleteContribution(id);
            console.log('Contribution supprimé :', contributionDelete);
        } catch (err) {
            console.error('Une erreur est survenue lors de la suppression de la contribution :', err);
        } finally {

            dispatch(fetchContributionsAndSousCategories(getParamsContribustions()))

        }
    }

    const getParamsContribustions = () => {

        const { locale, nationale, sousCategories, dateMin, dateMax } = contributionsFilter

        const categories = [
            locale ? "Locale" : null,
            nationale ? "Nationale" : null
        ].filter(Boolean);

        const sousCategoriesEncoded = `${ encodeURIComponent(JSON?.stringify(sousCategories)) }`;
        const categoriesEncoded = `${ encodeURIComponent(JSON?.stringify(categories)) }`;
        const offset = (currentPage - 1) * contributionsPerPage

        return new URLSearchParams({
            categories: categoriesEncoded,
            sousCategories: sousCategoriesEncoded,
            dateMin: dateMin,
            dateMax: dateMax,

            offset: offset,
            limit: contributionsPerPage,
            admin: isRenderedAsAdmin(keycloakReduce),
        }).toString()
    }

    return (
        <Container className={ `contribution-section ${ isInfosGeneralesPage ? "mt-3 container" : "" }` }>

            <div className="card h-100">

                { isInfosGeneralesPage ? (
                    <div
                        className={ `card-header d-flex align-items-center justify-content-between
                        ${ isInfosGeneralesPage ? 'header-rose' : 'header-rose' }` }>
                        <h1 className="my-2">
                            <a id="infos-gen">INFOS GENERALES</a>
                        </h1>
                        <small>
                            <div className='left-bordure-bleue ps-2'>Locale</div>
                            <div className='left-bordure-turquoise ps-2 mt-1'>Nationale</div>
                        </small>
                    </div>
                ) : (
                    <a id="infos-gen" className={ 'unstyled-link' }
                       onClick={ () => navigate(ROUTES?.PAGES?.INFOS_GENERALES) }>
                        <div
                            className={ `card-header d-flex align-items-center justify-content-between unstyled-link
                            ${ isInfosGeneralesPage ? 'header-rose' : 'header-rose' }` }>
                            <h1 className="my-2">
                                <>INFOS GENERALES</>
                            </h1>
                            <small>
                                <div className='left-bordure-bleue ps-2'>Locale</div>
                                <div className='left-bordure-turquoise ps-2 mt-1'>Nationale</div>
                            </small>
                        </div>
                    </a>
                ) }

                <div className="card-body contribution-card">

                    { isInfosGeneralesPage && (
                        <form
                            onSubmit={ rechercheContributions }
                            className=''>
                            <div className="row">
                                <div className="col-12">
                                    <div
                                        className="d-flex justify-content-between align-items-center flex-wrap px-3 border-bottom">

                                        <div
                                            className="btn-group my-3" role="group"
                                            aria-label="Basic checkbox toggle button group btn-test">
                                            <input
                                                type="checkbox"
                                                className="btn-check"
                                                id="btnLocale"
                                                name="locale"
                                                onChange={ handleInput }
                                                autoComplete="off"/>
                                            <label className="btn btn-custom-locale m-0"
                                                   htmlFor="btnLocale">Locale</label>

                                            <input
                                                type="checkbox"
                                                className="btn-check"
                                                id="btnNationale"
                                                name="nationale"
                                                onChange={ handleInput }
                                                autoComplete="off"/>
                                            <label className="btn btn-custom-nationale m-0"
                                                   htmlFor="btnNationale">Nationale</label>
                                        </div>

                                        <div className="row align-items-center my-3">
                                            <div className="dropdown col-auto" ref={ dropdownRef }>
                                                <button
                                                    className="btn btn-secondary dropdown-toggle"
                                                    type="button"
                                                    id="dropdownMenuButton"
                                                    onClick={ toggleDropdown }
                                                >
                                                    { contributionsFilter?.sousCategories.length > 0 ? contributionsFilter?.sousCategories.join(', ') : "Sous-catégories" }
                                                </button>
                                                { dropdownOpen && (
                                                    <ul className="dropdown-menu show"
                                                        aria-labelledby="dropdownMenuButton">
                                                        { sousCategoriesRef.map(sousCategorie => (
                                                            <li key={ sousCategorie } className="dropdown-item">
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        value={ sousCategorie }
                                                                        id={ sousCategorie }
                                                                        onChange={ handleCheckboxChange }
                                                                        checked={ contributionsFilter?.sousCategories.includes(sousCategorie) }
                                                                    />
                                                                    <label className="form-check-label"
                                                                           htmlFor={ sousCategorie }>
                                                                        { sousCategorie }
                                                                    </label>
                                                                </div>
                                                            </li>
                                                        )) }
                                                    </ul>
                                                ) }
                                            </div>
                                        </div>

                                        <div className="row align-items-center my-3">
                                            <div className="col-auto">
                                                <label htmlFor="dateMin">Depuis :</label>
                                            </div>
                                            <div className="col-auto">
                                                <input
                                                    id="dateMin"
                                                    name="dateMin"
                                                    className="form-control"
                                                    type="date"
                                                    value={ contributionsFilter?.dateMin }
                                                    onChange={ handleInput }/>
                                            </div>
                                        </div>

                                        <div className="row align-items-center my-3">
                                            <div className="col-auto">
                                                <label htmlFor="dateMax">Jusqu&apos;au :</label>
                                            </div>
                                            <div className="col-auto">
                                                <input
                                                    id="dateMax"
                                                    name="dateMax"
                                                    className="form-control"
                                                    type="date"
                                                    value={ contributionsFilter?.dateMax }
                                                    onChange={ handleInput }/>
                                            </div>
                                        </div>

                                        <div className="my-3">
                                            <button className="btn btn-primary" type='submit'>
                                                Rechercher
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </form>
                    ) }

                    <ul className='list-group'>

                        { contributions?.length > 0 && contributions?.map(contribution => {

                            const first60Words = extractFirstWordsWithoutImages(contribution?.corps)

                            const beforePublication = isAfterToday(contribution?.datePublication)
                            const afterPublicationEnd = isBeforeToday(contribution?.dateFinPublication)

                            const publicationBackgroundColor = ` ${ afterPublicationEnd
                                ? 'contribution-after-publication'
                                : beforePublication ? 'contribution-before-publication'
                                    : '' }`

                            if ((contribution?.dateFinPublication && isAfterToday(contribution?.dateFinPublication))
                                || !contribution?.dateFinPublication
                                || (isRenderedAsAdmin(keycloakReduce))) {
                                return (
                                    <li key={ contribution?.id }
                                        className={ `list-group-item 
                                            ${ contribution?.categorie === 'Nationale' ? 'left-bordure-bleue ps-2' : 'left-bordure-turquoise ps-2' }
                                            ${ publicationBackgroundColor }` }>
                                        <h3 className="text-start">
                                            <button
                                                className='btn-link btn'
                                                onClick={ () => voirContribution(contribution?.id) }>
                                                { contribution?.title }
                                            </button>
                                        </h3>
                                        <div className="d-flex justify-content-end">
                                            <small>
                                                Publiée le
                                                : { fromIso8601ToDdSlashMmSlashYyyy(contribution?.date) } | { contribution?.categorie } | { contribution?.sousCategorie }
                                                { isRenderedAsAdmin(keycloakReduce) ? (<>
                                                    <span className='grey-text'>
                                                        <span
                                                            className={ `${ beforePublication ? 'contribution-out' : '' }` }>
                                                            &nbsp;| date de publication : { fromDateInputToDdSlashMmSlashYyyy(contribution?.datePublication) }
                                                        </span>
                                                        <span
                                                            className={ `${ afterPublicationEnd ? 'contribution-out' : '' }` }>
                                                             &nbsp;| date de fin de publication : { fromDateInputToDdSlashMmSlashYyyy(contribution?.dateFinPublication) }
                                                        </span>
                                                    </span>
                                                </>) : '' }
                                            </small>
                                        </div>
                                        <div
                                            className="mt-3"
                                            dangerouslySetInnerHTML={ sanitizedMsg(first60Words + " ...") }>
                                        </div>

                                        <div className='float-end mt-3'>
                                            <button
                                                className="btn btn-primary"
                                                onClick={ () => voirContribution(contribution?.id) }>
                                                Lire l'article
                                            </button>
                                            { isRenderedAsAdmin(keycloakReduce) ? (<>
                                                <button
                                                    className="btn btn-secondary ms-2"
                                                    onClick={ () => supprimerContribution(contribution?.id) }>
                                                    Supprimer
                                                </button>
                                            </>) : '' }
                                        </div>
                                    </li>
                                )
                            }
                        }) }
                    </ul>

                    <div className='mt-3 me-3 d-flex justify-content-end'>
                        <PaginationSimple
                            currentPage={ currentPage }
                            totalRecords={ nombreContributions }
                            recordsPerPage={ contributionsPerPage }
                            setCurrentPage={ setCurrentPage }
                        />
                    </div>
                </div>
            </div>

            { isInfosGeneralesPage && isAdminKc(keycloakReduce?.decodedToken) ? (
                <div className="float-end mt-3">
                    <button className="btn btn-primary" type='button' onClick={ () => {
                        dispatch(updateKeycloak({ isRenderedAsAdmin: !keycloakReduce?.isRenderedAsAdmin }))
                    } }>
                        { isRenderedAsAdmin(keycloakReduce) ? "Mode utilisateur" : "Mode admin" }
                    </button>
                </div>
            ) : '' }
        </Container>
    )
}